import { render } from "./CommissionParticipantBlock.vue?vue&type=template&id=351ed696&scoped=true"
import script from "./CommissionParticipantBlock.vue?vue&type=script&lang=js"
export * from "./CommissionParticipantBlock.vue?vue&type=script&lang=js"

import "./CommissionParticipantBlock.vue?vue&type=style&index=0&id=351ed696&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351ed696"]])

export default __exports__